module.exports = " /* table.table.table-padded.customer-tracker tbody td span {  */\n    /* padding: 10px; */\n    /* padding: 0.9rem 15px;\n    word-break: break-word;\n} */\n    /* break{\n    padding: 0.9rem 15px;\n    word-break: break-word; \n} */\n    .fonts{\n    word-break: break-word; \n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/fiattransactions/transactions.component.css
// module id = ./src/app/fiattransactions/transactions.component.css
// module chunks = main